import { Box, Stack, Text } from '@chakra-ui/react';
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NavGroup = function NavGroup(props) {
  var label = props.label,
      children = props.children,
      showSideBar = props.showSideBar,
      _props$showBorder = props.showBorder,
      showBorder = _props$showBorder === void 0 ? false : _props$showBorder;
  return /*#__PURE__*/_jsxs(Box, {
    mt: 0,
    pb: showSideBar ? 3 : 1,
    borderBottomWidth: 1,
    borderColor: "#E7E7E7",
    e2eid: "ShellWithGroupedMenu_NavGroup_Box",
    children: [showSideBar ? /*#__PURE__*/_jsx(Text, {
      px: 3,
      mb: 2,
      fontSize: "14px",
      fontWeight: "semibold",
      e2eid: "ShellWithGroupedMenu_NavGroup_Text",
      children: label
    }) : null, /*#__PURE__*/_jsx(Stack, {
      spacing: "1",
      e2eid: "ShellWithGroupedMenu_NavGroup_Stack",
      children: children
    })]
  });
};